import React from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, IconButton, Typography, Box } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';

const ClientInactiveDialog = ({
  open,
  onClose,
  t,
  handleActivateClient
}) => (
  <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
    <DialogTitle sx={{ margin: '0 auto' }}>
      <Box display="flex" alignItems="center" justifyContent='center'>
        <WarningIcon color="warning" fontSize="large" />
        <Typography variant="h6" sx={{ ml: 1, fontWeight: 'bold' }}>
          {t('ClientInactive')}
        </Typography>
        <IconButton aria-label="close" onClick={onClose} sx={{ ml: 'auto', color: 'gray' }}>
          <CloseIcon />
        </IconButton>
      </Box>
    </DialogTitle>
    <DialogContent dividers>
      <Box display="flex" alignItems="center" justifyContent="center">
        <DialogContentText align="center" sx={{ color: 'gray', mb: 2 }}>
          {t('ClientInactivePrompt')}
        </DialogContentText>
      </Box>
    </DialogContent>
    <DialogActions sx={{ justifyContent: 'center' }}>
      <Button
        onClick={onClose}
        variant="outlined"
        color="error"
        startIcon={<CloseIcon sx={{ marginLeft: '8px' }} />}
        sx={{ textTransform: 'none', fontWeight: 'bold', borderRadius: '20px', padding: '8px 24px', marginLeft: '20px' }}
      >
        {t('No')}
      </Button>
      <Button
        onClick={handleActivateClient}
        variant="contained"
        color="success"
        startIcon={<CheckIcon sx={{ marginLeft: '8px' }} />}
        sx={{ textTransform: 'none', fontWeight: 'bold', borderRadius: '20px', padding: '8px 24px', marginLeft: '20px' }}
      >
        {t('Yes')}
      </Button>
    </DialogActions>
  </Dialog>
);

ClientInactiveDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  handleActivateClient: PropTypes.func.isRequired
};

export default ClientInactiveDialog;
